import * as React from "react";
import { useCookieConsentContext, isCookieCategoryEnabled } from "@grandvisionhq/cookie-consent";
const MONETATE_INIT = "var monetateT = new Date().getTime();";
function MonetateScript({ ScriptComponent, src }) {
  const strategy = React.useRef("beforeInteractive");
  const consentResult = useCookieConsentContext();
  if (!isCookieCategoryEnabled("functional", consentResult)) {
    strategy.current = "afterInteractive";
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ScriptComponent, { strategy: strategy.current }, MONETATE_INIT), /* @__PURE__ */ React.createElement(ScriptComponent, { strategy: strategy.current, src }));
}
export {
  MonetateScript
};
//# sourceMappingURL=script.js.map
